import * as io from "io-ts";
import * as Either from "fp-ts/Either";
import * as Task from "fp-ts/Task";
import * as TaskEither from "fp-ts/TaskEither";
import { pipe } from "fp-ts/lib/function";
import type { Errors } from "io-ts";
import type { DashboardImportT } from "../../../schema/dashboard";
import { DashboardImport } from "../../../schema/dashboard";

/**
 * @description
 * Utility Dashboard file schema to check for
 * the name & size of File returned by the input[type="file"].
 */
const DashboardFile = io.strict({
  name: io.refinement(io.string, s => s.endsWith(".json")),
  size: io.refinement(io.number, n => n > 0),
});

/**
 * @description
 * Dashboard file parser.
 * Implemented with fp-ts to have a better
 * integration with io-ts parsing result.
 */
export function parseDashboardFile(file: File) {
  return pipe(
    Task.of(file),
    Task.chain(f => TaskEither.fromEither(DashboardFile.decode(f))),
    Task.chain(f =>
      TaskEither.tryCatch<Errors, DashboardImportT>(
        async () => (Either.isRight(f) ? JSON.parse(await file.text()) : Either.toError(f)),
        e => e as Errors,
      ),
    ),
    TaskEither.chain(json => TaskEither.fromEither(DashboardImport.decode(json))),
  )();
}
